import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  Spinner,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import { FiArrowLeft, FiPlus, FiXCircle } from "react-icons/fi";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NumericFormat, PatternFormat } from "react-number-format";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { useEffect, useState } from "react";
import ExtratoApi from "../../../../services/ExtratoAPI";
import PaymentApiNovo from "../../../../services/paymentApiNovo";
import ClientApi from "../../../../services/clientApi";
import {
  dateForList,
  dateForValueInput,
} from "../../../../constants/dataFormat";
import { goToPaymentSolicitationListNew } from "../../../../routes/coordinator";
import { JWTToken } from "../../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { customColors } from "../../../../atoms/customColors";
import ModalConfirmTransf from "./modalConfirmTransf";
import { LoggedUser } from "../../../../atoms/userLogged";
const utils = require("@mrmgomes/boleto-utils");

function AddPaymentNew() {
  const navigate = useNavigate();

  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const [cliente, setCliente] = useState(0);
  const todayMorning = moment()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const todayNight = moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS");
  const [saldoCliente, setSaldoCliente] = useState(0);
  const [nomeCliente, setNomeCliente] = useState("");
  const [loading, setLoading] = useState(false);

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const id = Number(jwtToken.idCliente);
  const colors = useRecoilState(customColors)[0];

  interface IFormInputs {
    idCliente: any;
    codigoBarras: string;
    valorPagamento: number;
    dataPagamento: string;
  }

  const initialValues = {
    idCliente: id,
    codigoBarras: "",
    valorPagamento: 0,
    dataPagamento: moment().format("DD/MM/YYYY"),
  };

  const [pagamento, setPagamento] = useState<IFormInputs>(initialValues);
  const [listaPagamento, setListaPagamento] = useState<IFormInputs[]>([]);

  let hasPermission42 = false;
  if (token && typeof token === "string" && token.includes(".")) {
    try {
      const decodedToken: JWTToken & { loginPermissoes?: string } =
        jwt_decode(token);
      if (decodedToken.loginPermissoes) {
        hasPermission42 = decodedToken.loginPermissoes.includes("42");
      } else if (decodedToken.loginPermissoes) {
        try {
          const loginPermissoes: number[] = JSON.parse(
            decodedToken.loginPermissoes
          );
          hasPermission42 = loginPermissoes.includes(42);
        } catch (parseError) {}
      }
    } catch (error) {}
  }

  useEffect(() => {
    setPagamento((prevState) => ({
      ...prevState,
      dataPagamento: moment().format("DD/MM/YYYY"),
    }));
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm<IFormInputs>();

  async function getSaldo() {
    try {
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        todayMorning,
        todayNight,
        id
      );
      setSaldoCliente(
        response.data[0] &&
          response.data[0].saldoAnterior + response.data[0].saldoPeriodo
      );
    } catch (error) {
      console.log("getSaldo - Erro:", error);
    }
  }
  useEffect(() => {
    getSaldo();
  }, []);

  const [code, setCode] = useState("");
  const [openCodeModal, setOpenCodeModal] = useState(false);
  const user = useRecoilState(LoggedUser)[0];

  function onSubmit() {
    if (pagamento.codigoBarras !== "" && pagamento.dataPagamento !== "") {
      if (pagamento.valorPagamento > saldoCliente) {
        toast.error("O saldo é insuficiente para a operação!");
      } else {
        const objeto = {
          idCliente: id,
          codigoBarras: pagamento.codigoBarras,
          dataPagamento: moment(pagamento.dataPagamento).format("YYYY-MM-DD"),
          valorPagamento: pagamento.valorPagamento,
        };
        setListaPagamento([...listaPagamento, objeto]);
        setPagamento(objeto);
        setCliente(0);
        setOpenCodeModal(true);
      }
    } else {
      toast.error("Preencha os campos para registrar a solicitação!");
    }
  }

  async function postPagamentos(codeResponse: string) {
    try {
      setLoading(true);

      const pagamentoObj = listaPagamento[0] || {};
      const response = await PaymentApiNovo.postPaymentSolicitation(
        pagamentoObj,
        codeResponse
      );
      toast.success("Solicitação de pagamento registrada com sucesso!");
      toast.success("Seu boleto será processado em breve!");
      setRefreshGlobal(refresh + 1);
      setListaPagamento([]);
      goToPaymentSolicitationListNew(navigate);
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível cadastrar a solicitação");
      setLoading(false);
    }
  }

  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  async function getClientPerId() {
    try {
      const response = await ClientApi.getClientPerId(id);
      setNomeCliente(
        response.isCnpj === true
          ? response.razaoSocial
          : `${response.nome} ${response.sobrenome}`
      );
    } catch (error) {
      console.log("getClientPerId - Erro:", error);
    }
  }
  useEffect(() => {
    getClientPerId();
  }, []);

  function getInformationByBarCode(item: any) {
    const _item = item.replace(/[^0-9]/g, "");
    if (_item.length <= 48) setPagamento({ ...pagamento, codigoBarras: _item });

    if (_item.length < 44 || _item.length > 48) {
      setError("codigoBarras", {
        type: "onBlur",
        message:
          "O código de barras ou linha digitável deve ter entre 44 e 48 caracteres.",
      });
      return;
    } else {
      setError("codigoBarras", {
        type: "onBlur",
        message: "",
      });
    }

    if (_item === "") {
      setError("codigoBarras", {
        type: "onBlur",
        message: "Digite o código do boleto.",
      });
    }
  }

  const MASK_ARRECADACAO44 =
    "#####.##### #####.###### #####.###### # ##############";
  const MASK_COBRANCA47 = "#####.##### #####.###### #####.###### # ###########";
  const MASK_COBRANCA48 =
    "#####.##### #####.###### #####.###### #####.###### ##";
  const NO_MASK = "################################################";

  const [isLeitorCodigos, setIsLeitorCódigo] = useState(false);

  const handleChange = () => {
    setIsLeitorCódigo(!isLeitorCodigos);
    setPagamento({
      ...pagamento,
      codigoBarras: "",
    });
  };

  const transferData = {
    ...pagamento,
    idCliente: id,
  };

  return (
    <Flex flexDir={"column"} height="fit-content" width="100%">
      <Box
        width={"100%"}
        bgColor={colors.WHITE}
        height={"fit-content"}
        shadow={"md"}
        justifyItems={"center"}
        mt={"0.3%"}
        mx="auto"
        py={2}
        px={3}
      >
        <Flex
          px={5}
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Text fontWeight="bold" fontSize="18px">
            Nova Solicitação de Pagamento de Boletos Novo
          </Text>
          <Button
            leftIcon={<FiArrowLeft />}
            bgColor={colors.GRAY_NEUTRAL}
            style={{ color: "white" }}
            onClick={() => {
              goToPaymentSolicitationListNew(navigate);
            }}
          >
            Voltar
          </Button>
        </Flex>
      </Box>
      <Flex w={"100%"} h={"84vh"} overflowY={"scroll"} flexDirection={"column"}>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          justifyItems={"center"}
          mt={"0.3%"}
          mx="auto"
          py={2}
          px={3}
        >
          <Flex
            justify="flex-start"
            ml={4}
            flexDirection={"column"}
            color={colors.BLUEMONEDD}
          >
            <Text fontSize={"12px"} my={1}>
              Informe os dados a seguir e clique em adicionar.
            </Text>
            <Text fontSize={"12px"} my={1}>
              Atenção: No campo valor, informe o valor correto a ser pago do
              boleto.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Solicitações de pagamentos bancários só são possíveis de 08h até
              às 17h, de segunda a sexta, exceto feriados.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Não é possível realizar solicitações de pagamentos bancários
              após as 17h, finais de semana e feriados.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Cliente Monedd tem direito a pagamentos de boletos sem custo e
              sem limite de quantidade.
            </Text>
          </Flex>
        </Box>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          mt={"0.3%"}
          mx="auto"
          py={3}
          px={10}
        >
          <Flex width={"100%"} height={"60%"} flexDirection="column" mb={"3%"}>
            <form>
              <Flex my={2} flexDirection={"column"}>
                <Text fontWeight={"bold"} my={1}>
                  Saldo:{" "}
                  {loading ? (
                    <Spinner
                      size={"sm"}
                      color={colors.BLUEMONEDDBUTTONS}
                    ></Spinner>
                  ) : hasPermission42 ? (
                    "****"
                  ) : saldoCliente ? (
                    saldoCliente.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  ) : (
                    "R$ 0,00"
                  )}
                </Text>
              </Flex>
              <Flex>
                <FormControl>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Código de Barras ou Linha Digitável
                  </FormLabel>
                  <PatternFormat
                    customInput={Input}
                    format={NO_MASK}
                    placeholder={"Código de Barras ou Linha digitável"}
                    value={pagamento.codigoBarras}
                    {...register("codigoBarras", { required: true })}
                    onChange={(e: any) => {
                      const unmaskedValue = unMask(e.target.value);
                      if (unmaskedValue.length <= 48) {
                        setPagamento((prev) => ({
                          ...prev,
                          codigoBarras: unmaskedValue,
                        }));
                        getInformationByBarCode(unmaskedValue);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  />
                  <Text color={colors.REDMONEDD}>
                    {errors.codigoBarras?.message}
                  </Text>
                </FormControl>
              </Flex>
              <Flex flexDir={"row"}></Flex>
              <Button
                onClick={() => onSubmit()}
                mt={5}
                leftIcon={<FiPlus />}
                bgColor={colors.BLUEMONEDDBUTTONS}
                style={{ color: "white" }}
                _hover={{ bg: "#4B4B57" }}
              >
                Cadastrar
              </Button>
            </form>
          </Flex>
        </Box>
      </Flex>
      <ModalConfirmTransf
        isOpen={openCodeModal}
        setIsOpen={setOpenCodeModal}
        functionPai={postPagamentos}
        setCode={setCode}
        type={"pagamento"}
        email={user.email}
        transferData={transferData}
      />
    </Flex>
  );
}

export default AddPaymentNew;
